<template>
  <div class="d-flex flex-column align-items-center">
    <div class="authentication-heading w-100 d-flex justify-content-around">
      <div class="h1 text-center m-0">{{ $t('forgot_password.title') }}</div>
    </div>
    <span>{{ $t('forgot_password.heading') }}</span>
    <div class="authentication-buttons-spacer d-flex flex-column w-100">
      <router-link :to="{ name: 'authentication.login' }"
        ><button type="button" class="btn btn-outline-light w-100">{{ $t('forgot_password.buttons.go_back') }}</button></router-link
      >
    </div>
  </div>
</template>

<style scoped>
span {
  color: white;
  font-family: 'Roboto', sans-serif;
}
</style>
